// removed by extract-text-webpack-plugin
module.exports = {"bg":"_2Ba5G","base":"_9ejun","sectionHeader":"_1dLsc","title":"_2Brdy","content":"_35E9g","spinner":"_26FGK","list":"_19zRh","fieldset":"_13f_Z","form":"_157g9","group":"_3gnAq","footer":"_3lTLF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/PartnerPlanStatusDisplayForm.scss
// module id = 2445
// module chunks = 0